import { Box } from '@mui/material'
import { t } from 'i18next'
import React from 'react'
import { Controller } from 'react-hook-form'
import DateInput from 'src/Common/ui/dateInput'
import Textarea from 'src/Common/ui/textArea'
import { ACCEPTANCE_ID } from 'src/Entities/RiskTypes'
import { cn, inputValidation } from 'src/lib/utils'

export default function Justification ({ data, reviewDate, type, onInputChange, control, errors, label = 'Justification' }) {
    return (
        <>
            <Box display="grid" gridTemplateColumns={type === ACCEPTANCE_ID ? '1fr 3fr' : '3fr 1fr'} gap={2}>
                {type === ACCEPTANCE_ID && (<>
                    <Box gridColumn="span 1">

                        <Controller name="actions"
                            rules={type === ACCEPTANCE_ID ? { required: 'This field is Required' } : {}}
                            control={control}
                            errors={errors}
                            render={({ field: { onChange } }) => (<Box gridColumn="span 4">
                                <DateInput
                                    label={'Review Date'}
                                    required
                                    name="selectedDate"
                                    className={'input-grc'}
                                    value={reviewDate}
                                    defaultValue={reviewDate}
                                    onValueChange={(e) => {
                                        const val = e
                                        onInputChange('reviewDate', e)
                                        onChange(val)
                                    }}
                                />
                            </Box>)}
                        />
                        {errors && <p className='grc-error-msg text-danger'>{errors && 'selectedDate' && errors.selectedDate?.message}</p>}
                    </Box>

                </>
                )
                }
                <Box gridColumn="span 1">

                    <div className='relative' style={{ marginBottom: '2%' }}>
                        <Textarea className={cn('ml-[0px]')} label={label} rules={{
                            validate: (value) => {
                                return inputValidation(value, value?.length < 251, t('This field is required'), t('Characters should be less than 250'))
                            }
                        }} value={data}
                        onValueChange={(e) => onInputChange('justification', e?.slice(0, 250))}
                        defaultValue={data}type="text" placeholder={`Enter ${label}`} name="ImpactOfRisk" errors={errors} control={control} required maxLength={250} />
                        <div className={cn('absolute bottom-[25px] right-[10px] text-muted text-[10px]', data?.length > 250 ? '!text-danger' : 'text-muted')}>{data?.length || 0}/250</div>
                    </div>
                </Box>

            </Box>
        </>
    )
}
